import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import FormTextField from 'components/common/FormTextField';
import * as valid from 'utils/validation';
import { withRouter } from 'react-router-dom';
import { editPassword } from 'store/admin';
import { Option } from 'utils/commonValues';

// import logoImage from "img/logo/m_logo.png";
// import sLogoImage from 'img/logo/s_logo.png';

function Adminfirst(props: any) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<any>({
    type: '',
    content: '',
  });
  const { formatMessage } = useIntl();

  const { errors, register, getValues, handleSubmit } = useForm({
    mode: 'all',
  });
  const { beforePassword, userPasswd, userPasswdCheck } = getValues();

  const onAdminInitSetting = async (formData: any) => {
    if (!loading) {
      setLoading(true);
      try {
        if (formData.userPasswd === formData.userPasswdCheck) {
          const params = {
            beforePasswd: formData.beforePassword,
            newPasswd: formData.userPasswd,
          };

          const respObj: any = await dispatch(editPassword(params));
          if (respObj?.status === 200) {
            if (respObj.data && Array.isArray(respObj.data.list)) {
              setErrorMessage({
                type: 'success',
                content: (
                  <div>
                    <div className="confirm-message">
                      {formatMessage({ id: 'FirstLogin_4', defaultMessage: '변경 완료!' })}
                    </div>
                  </div>
                ),
              });
            } else if (Array.isArray(respObj.data.error)) {
              if (respObj.data.error[0].errInfo === 'Passwd five time mismatched.'){
                respObj.data.error[0].errInfo = formatMessage({ id: 'Password_24', defaultMessage: '비밀번호가 5회 틀렸습니다.' })
              }
              setErrorMessage({
                type: 'beforePassword',
                content: respObj.data.error[0].errInfo,
              });
            } else {
              setErrorMessage({
                type: 'beforePassword',
                content: formatMessage({
                  id: 'Password_14',
                  defaultMessage: '비밀번호가 틀렸습니다.',
                }),
              });
            }
          }
        } else {
          setErrorMessage({
            type: 'userPasswdCheck',
            content: formatMessage({
              id: 'Password_15',
              defaultMessage: '비밀번호가 일치하지 않습니다.',
            }),
          });
        }

        setLoading(false);
      } catch (e) {
        console.log(e);
      }
    }
  };

  const onChangeForm = () => {
    setErrorMessage({ type: '', content: '' });
  };

  return (
    <div className="admin-first-edit-area change-passwd">
      <div className="display-flex">
        <img
          src="/img/logo/m_logo.png" // {Option.isSaxa === 1 ? sLogoImage : logoImage}
          alt="logo"
        />
        <div>
          <div className="admin-title">
            {formatMessage({ id: 'Password_16', defaultMessage: '비밀번호 기간 만료' })}
          </div>
          <div className="bold mt-5">
            {formatMessage({
              id: 'Password_18',
              defaultMessage: '비밀번호를 변경 해주세요.',
            })}
          </div>
        </div>
      </div>
      {errorMessage.type === 'success' ? (
        <>
          <div className="modify-confirm">{errorMessage.content}</div>
          <div className="button-area">
            <button
              className="bt-change"
              onClick={() => props.history.push('/mudlogin')}
              type="button"
            >
              {formatMessage({ id: 'Login_1', defaultMessage: '로그인' })}
            </button>
          </div>
        </>
      ) : (
        <div>
          <form
            onSubmit={handleSubmit(onAdminInitSetting)}
            onChange={onChangeForm}
            autoComplete="off"
          >
            <span className="text-field-title">
              {formatMessage({ id: 'Password_8', defaultMessage: '기존 비밀번호' })}
            </span>
            <div className="first-wrap-input">
              <FormTextField
                name="beforePassword"
                type="password"
                value={beforePassword}
                error={errors.beforePassword}
                errorCheck={errorMessage.type === 'beforePassword'}
                errorText={errorMessage.type === 'beforePassword' && errorMessage.content}
                register={register}
                validation={{
                  validate: {
                    required: (value: any) => valid.required(value),
                  },
                }}
              />
            </div>
            <span className="text-field-title">
              {formatMessage({ id: 'Password_9', defaultMessage: '새 비밀번호' })}
            </span>
            <div className="first-wrap-input">
              <FormTextField
                name="userPasswd"
                type="password"
                value={userPasswd}
                error={errors.userPasswd}
                errorCheck={errorMessage.type === 'userPasswd'}
                errorText={errorMessage.type === 'userPasswd' && errorMessage.content}
                register={register}
                validation={{
                  validate: {
                    required: (value: any) => valid.required(value),
                  },
                }}
              />
            </div>
            <span className="text-field-title">
              {formatMessage({ id: 'Password_10', defaultMessage: '새 비밀번호 확인' })}
            </span>
            <div className="first-wrap-input">
              <FormTextField
                name="userPasswdCheck"
                type="password"
                value={userPasswdCheck}
                error={errors.userPasswdCheck}
                errorCheck={errorMessage.type === 'userPasswdCheck'}
                errorText={errorMessage.type === 'userPasswdCheck' && errorMessage.content}
                register={register}
                validation={{
                  validate: {
                    required: (value: any) => valid.required(value),
                  },
                }}
              />
            </div>
            <div>
              <div className="button-area">
                <button className="bt-change" type="submit">
                  {formatMessage({ id: 'Button_1', defaultMessage: '변경' })}
                  {loading && (
                    <span className="button-loading">
                      <LoadingOutlined />
                    </span>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default withRouter(Adminfirst);
